import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { SUPPORTED_LANGUAGES } from '@/routes/routesList';
import { SwitcherContainer, SelectedLanguage, DropdownMenu, DropdownContent, LanguageOption, DropdownArrow } from './styled';
var LANGUAGE_NAMES = {
    en: 'English',
    ar: 'العربية',
    ru: 'Русский',
    fr: 'Français',
    de: 'Deutsch',
};
var LanguageSwitcher = function () {
    var _a = useLanguage(), language = _a.language, setLanguage = _a.setLanguage;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    return (_jsxs(SwitcherContainer, { onMouseLeave: function () { return setIsOpen(false); }, children: [_jsxs(SelectedLanguage, { onClick: function () { return setIsOpen(!isOpen); }, children: [LANGUAGE_NAMES[language], _jsx(DropdownArrow, { "$isOpen": isOpen, children: "\u25BC" })] }), isOpen && (_jsx(DropdownMenu, { children: _jsx(DropdownContent, { children: SUPPORTED_LANGUAGES.map(function (lang) { return (_jsx(LanguageOption, { "$active": lang === language, onClick: function () {
                            setLanguage(lang);
                            setIsOpen(false);
                        }, children: LANGUAGE_NAMES[lang] }, lang)); }) }) }))] }));
};
export default LanguageSwitcher;
